function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Transport = function Transport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "m17.83 6.52.417 2.77H5.743l.417-2.77c.2-1.32 1.31-2.28 2.65-2.28h6.37c1.33 0 2.45.96 2.65 2.28M3.169 9.785l-1.51-.735a.74.74 0 0 1-.34-1 .74.74 0 0 1 1-.34l1.978.963L4.66 6.3A4.15 4.15 0 0 1 8.8 2.75h6.37c2.08 0 3.82 1.5 4.14 3.56l.364 2.377 2.006-.977c.37-.18.82-.03 1 .34s.03.82-.34 1l-1.503.732a3.79 3.79 0 0 1 1.923 3.298v6.38c0 .96-.78 1.75-1.75 1.75l-3.37.03h-.02v.01a1.588 1.588 0 0 1-1.59-1.59v-1.12l-8.15-.04v1.12c0 .88-.71 1.59-1.59 1.59H3c-.96 0-1.75-.79-1.75-1.75v-6.38c0-1.41.774-2.642 1.919-3.295M2.74 13.09c0-1.188.916-2.171 2.076-2.28h14.358a2.297 2.297 0 0 1 2.076 2.28v6.38c0 .14-.11.25-.25.25l-3.38.03-.09-.09v-1.61c0-.55-.45-1-1-1l-9.15-.04h-.01c-.55 0-1 .45-1 1v1.62c0 .05-.04.09-.09.09H2.99c-.14 0-.25-.11-.25-.25zm3.22 1.57h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2c-.41 0-.75.34-.75.75s.34.75.75.75m10.08 0h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2c-.41 0-.75.34-.75.75s.34.75.75.75",
    clipRule: "evenodd"
  }));
};
export default Transport;
Transport.displayName = 'Transport';